import React, { useState } from 'react';
import { motion } from 'framer-motion';
import CapacitaSegModal from '../Modals/CapacitaSegModal';

const CapacitaSeg = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  return (
    <section className="py-16 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center gap-8">
          <motion.div 
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="md:w-1/2"
          >
            <img 
              src="/logos/capacitaseg-color.png" 
              alt="CapacitaSeg Logo" 
              className="w-full max-w-md mx-auto cursor-pointer"
              onClick={() => setIsModalOpen(true)}
            />
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, x: 50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="md:w-1/2"
          >
            <h2 className="text-3xl font-bold text-teal-700 mb-4">CapacitaSeg</h2>
            <p className="text-gray-700 mb-6">
              A CapacitaSeg é nossa divisão especializada em treinamentos corporativos e capacitação profissional. 
              Oferecemos cursos e workshops nas áreas de saúde e segurança do trabalho, atendendo às normas 
              regulamentadoras e necessidades específicas da sua empresa.
            </p>
            <button 
              onClick={() => setIsModalOpen(true)}
              className="inline-block bg-teal-600 hover:bg-teal-700 text-white font-medium py-2 px-6 rounded-md transition-colors"
            >
              Conhecer a CapacitaSeg
            </button>
          </motion.div>
        </div>
      </div>

      <CapacitaSegModal 
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
      />
    </section>
  );
};

export default CapacitaSeg;